import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import {
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexChart,
  ApexTheme,
  ApexTitleSubtitle,
  ApexFill,
  ApexStroke,
  ApexYAxis,
  ApexLegend,
  ApexPlotOptions,
} from 'ng-apexcharts';
import { ChartComponent } from 'ng-apexcharts';

import { ReportReferral } from '@core/models/statistics-report.model';
import { CapitalizeFirstLetterPipe } from '@shared/pipes/capitalize-first-letter.pipe';

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  theme: ApexTheme;
  title: ApexTitleSubtitle;
  fill: ApexFill;
  yaxis: ApexYAxis;
  stroke: ApexStroke;
  legend: ApexLegend;
  plotOptions: ApexPlotOptions;
};

@Component({
  selector: 'app-referral-companies-statistics',
  templateUrl: './referral-companies-statistics.component.html',
  styleUrls: ['./referral-companies-statistics.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [CapitalizeFirstLetterPipe],
})
export class ReferralCompaniesStatisticsComponent implements OnChanges {
  @Input() statistics: ReportReferral[] = [];
  @ViewChild('chart') chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  constructor(
    private readonly capitalizeFirstLetter: CapitalizeFirstLetterPipe,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.statistics) {
      this.refreshChart();
    }
  }

  private refreshChart(): void {
    this.chartOptions = {
      series: this.statistics.map((statistics) => statistics.totalRegister),
      labels: this.statistics.map((statistics) =>
        this.capitalizeFirstLetter.transform(statistics.referral.toLowerCase()),
      ),
      chart: {
        width: '100%',
        type: 'polarArea',
      },
      fill: {
        opacity: 1,
      },
      legend: {
        position: 'bottom',
        show: true,
      },
      stroke: {
        width: 2,
        colors: undefined,
      },
      yaxis: {
        show: false,
      },
      plotOptions: {
        polarArea: {
          rings: {
            strokeWidth: 0,
          },
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
      theme: {
        monochrome: {
          enabled: true,
          shadeTo: 'dark',
          shadeIntensity: 0.8,
        },
      },
    };
  }
}
